<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-layout class="response-insights pa-0" column fluid fill-height>
    <page-title title="Responses"></page-title>
    <Filters
      :metricFilter="true"
      :tagFilter="true"
      :commentedStatusFilte="true"
    ></Filters>
    <v-layout class="response-list pt-3" column fluid justify-center>
      <NoResult v-if="!loading && noData"></NoResult>
      <template v-if="!loading">
        <v-flex
          class="response-list-item"
          :key="response.id"
          v-for="response in responses"
          shrink
        >
          <v-layout class="pa-0">
            <v-flex xs3 class="score-area pa-0" justify-center align-center
              ><ResponseRatingAnswerDisplay
                :answer="response.answer"
                :ratingColors="colors"
                :ratingLabels="getRatingLabels(response.metric_type)"
                :type="response.metric_type"
              ></ResponseRatingAnswerDisplay
            ></v-flex>
            <v-flex xs9 class="response-area pa-2 pl-3 pr-3">
              <v-layout column fill-height space-between>
                <v-flex>
                  <v-layout class="top-section pa-0" space-between>
                    <v-flex>
                      <span class="customer-name">
                        {{ response.customer.name ? response.customer.name : 'User' }},
                      </span>
                      <span class="date-info"
                        >{{ getDate(response.responded_at) }} in
                      </span>
                      <span class="metric-type">{{
                        response.metric_type === 'NPS'
                          ? response.metric_type
                          : 'C' + response.metric_type
                      }}</span>
                    </v-flex>
                    <a
                      class="view-response-link"
                      @click.prevent="viewResponse(response)"
                      >View full response</a
                    >
                  </v-layout>
                </v-flex>

                <v-flex class="comment-text">
                  <span v-if="response.text">{{ response.text }}</span>
                  <span class="no-comments" v-else>
                    <!--No comment for this response-->
                  </span>
                </v-flex>
                <v-flex class="response-tags">
                  <TagManagement
                    :responseId="response.id"
                    :responseTagIds="response.tags"
                    :key="responseTagKey"
                  >
                  </TagManagement>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
      </template>
      <v-progress-circular indeterminate v-if="loading"></v-progress-circular>
    </v-layout>
    <div v-if="!loading && !noData" class="text-xs-center response-list-pagination">
      <v-pagination
        v-model="paging.page"
        :length="pages"
        @input="getData()"
        prev-icon="keyboard_arrow_left"
        next-icon="keyboard_arrow_right"
      ></v-pagination>
    </div>
    
    <v-navigation-drawer
      class="response-details-view"
      v-model="responseDetailsDrawer"
      fixed
      right
      temporary
      width="520"
    >
      <v-container
        fluid
        fill-height
        align-center
        justify-center
        class="response-details-content"
      >
        <v-progress-circular
          indeterminate=""
          v-if="responseDetailsLoading"
        ></v-progress-circular>
        <v-layout v-if="!responseDetailsLoading" column>
          <v-flex class="first-row" d-flex space-between align-center>
            <div>
              <span class="customer-name">
                        {{ responseDetails.customer.name ? responseDetails.customer.name : 'User' }},
                      </span>
              <span class="date-info"
                >{{ getDate(responseDetails.responded_at) }} in
              </span>
              <span class="metric-type">{{
                responseDetails.metric_type === 'NPS'
                  ? responseDetails.metric_type
                  : 'C' + responseDetails.metric_type
              }}</span>
              <div class="customer-unique-id" v-if="responseDetails.customer.unique_id">
              {{ responseDetails.customer.unique_id }}
              </div>
            </div>

            <v-icon class="close-icon" @click="responseDetailsDrawer = false"
              >close</v-icon
            >
            
          </v-flex>
          
          <v-flex
            class="question"
            v-for="question in responseDetails.questions"
            :key="question.id"
            d-block
          >
            <div
              class="metric-type metric-label"
              v-if="question.type === 'METRIC'"
            >
              {{
                responseDetails.metric_type === 'NPS'
                  ? responseDetails.metric_type
                  : 'C' + responseDetails.metric_type
              }}
            </div>
            <div class="driver metric-label" v-if="question.type === 'DRIVER'">
              Drivers
            </div>
            <div
              class="driver metric-label"
              v-if="question.type === 'OPEN_ENDED'"
            >
              Open-ended
            </div>
            <div class="">
              <NpsQuestion
                v-if="
                  question.type === 'METRIC' &&
                    responseDetails.metric_type === 'NPS'
                "
                :question="question.question"
                :buttonShape="'SQUARE'"
                :color="constants.colors.theme.primary"
                :borderColor="constants.colors.theme.primaryLight5"
                :brandName="$store.getters['user/currentCampaign'].brand_name"
                :value="question.answer"
                readonly
                :size="35"
                :npsButtonLabelColor="constants.colors.theme.primaryLight1"
              ></NpsQuestion>
              <SingleChoiceQuestion
                v-if="
                  question.type === 'METRIC' &&
                    responseDetails.metric_type === 'SAT'
                "
                :color="constants.colors.theme.primary"
                :borderColor="constants.colors.theme.primaryLight5"
                :organColor="constants.colors.theme.primaryLight5"
                :brandName="$store.getters['user/currentCampaign'].brand_name"
                :options="strings.SAT.widget_button_labels"
                :question="question.question"
                :value="question.answer"
                readonly
              >
              </SingleChoiceQuestion>
              <SingleChoiceQuestion
                v-if="
                  question.type === 'METRIC' &&
                    responseDetails.metric_type === 'ES'
                "
                :color="constants.colors.theme.primary"
                :borderColor="constants.colors.theme.primaryLight5"
                :organColor="constants.colors.theme.primaryLight5"
                :brandName="$store.getters['user/currentCampaign'].brand_name"
                :options="strings.ES.widget_button_labels"
                :question="question.question"
                :value="question.answer"
                readonly
              >
              </SingleChoiceQuestion>
              <DriverQuestion
                v-if="question.type === 'DRIVER'"
                :color="constants.colors.theme.primary"
                :textColor="constants.colors.theme.primaryLight1"
                :borderColor="constants.colors.theme.primaryLight5"
                :brandName="$store.getters['user/currentCampaign'].brand_name"
                :value="question.answer"
                :question="question.question"
                :options="question.options"
                readonly
                :verticalPadding="5"
              ></DriverQuestion>
              <OpenendedQuestion
                v-if="question.type === 'OPEN_ENDED'"
                :brandTitle="$store.getters['user/currentCampaign'].brand_name"
                :question="question.question"
              >
                <template v-slot:question-options>
                  <div class="text-suggestion">
                    {{ question.answer }}
                  </div>
                </template>
              </OpenendedQuestion>
            </div>
          </v-flex>
          <v-flex class="bottom-row">
            <v-dialog v-model="deleteDialog" width="500" light>
              <template v-slot:activator="{ on }">
                <img
                  v-on="on"
                  class="delete-img"
                  :src="require('@/assets/delete.svg')"
                />
              </template>

              <v-card >
                <v-card-title
                  class="headline  dark lighten-2"
                  warning-title
                >
                  Delete response
                </v-card-title>

                <v-card-text>
                  Are you sure to delete this response?
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    depressed
                    color="primaryLight4"
                    outline
                    @click="deleteDialog = false"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    color="warning"
                    :loading="deleteLoading"
                    depressed
                    dark
                    @click="deleteResponse()"
                  >
                    Delete
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-flex>
        </v-layout>
      </v-container>
    </v-navigation-drawer>
  </v-layout>
</template>

<script>
import distanceInWords from 'date-fns/distance_in_words'
import EventBus from '@/event_bus'
import Filters from '@/components/insights/Filters'
import ResponseRatingAnswerDisplay from '@/components/insights/ResponseRatingAnswerDisplay'
import TagManagement from '@/components/TagManagement'
import insightsApi from '@/api/insights'
import constants from '@/constants'
import strings from '@/strings'
import NpsQuestion from '../../../../widgets/feedback/src/components/NpsQuestion'
import DriverQuestion from '../../../../widgets/feedback/src/components/DriverQuestion'
import SingleChoiceQuestion from '../../../../widgets/feedback/src/components/SingleChoiceQuestion'
import OpenendedQuestion from '../../../../widgets/feedback/src/components/OpenendedQuestion'
import NoResult from '@/components/insights/NoResult'
import filterMixins from '@/mixins/filter'
export default {
  name: 'ResponseListView',
  mixins:[filterMixins],
  components: {
    Filters,
    ResponseRatingAnswerDisplay,
    TagManagement,
    NpsQuestion,
    DriverQuestion,
    SingleChoiceQuestion,
    OpenendedQuestion,
    NoResult
  },
  data: function() {
    return {
      responses: [],
      paging: { limit: 10, page: 1 },
      tags: [],
      pages: 0,
      loading: true,
      noData: false,
      responseDetailsDrawer: false,
      responseDetailsLoading: true,
      responseDetails: null,
      constants: constants,
      deleteDialog: false,
      deleteLoading: false,
      strings: strings,
      responseTagKey: Math.random().toString(36).substring(7)
    }
  },
  mounted() {
    const vm = this
    this.$store
      .dispatch('campaign/getTags', {
        campaignId: this.$router.currentRoute.params.campaignId
      })
      .then(function(data) {
        vm.getCount()
        vm.getData()
      })
    EventBus.$on('refreshTags', function() {
      // console.log('refreshTags')
      // vm.$forceUpdate()
      vm.responseTagKey = Math.random().toString(36).substring(7)
    })
  },
  watch: {
    $route: function() {
      this.paging.page = 1
      this.getCount()
      this.getData()
    },
    responseDetailsDrawer: function(val, prev) {
      if (val) {
        document.getElementsByTagName('html')[0].style.overflowY = 'hidden'
      } else {
        document.getElementsByTagName('html')[0].style.overflowY = 'auto'
      }
    }
  },
  methods: {
    getData: function() {
      this.loading = true
      const vm = this
      insightsApi
        .getResponses(
          this.$router.currentRoute.params.campaignId,
          this.getFilters()
        )
        .then(function(res) {
          if(res.data.results.length === 0){
            vm.noData = true
            vm.loading = false
            vm.responses = []
            return
          }
          else{
            vm.noData = false
          }
          vm.responses = res.data.results.map(function(d) {
            d.addingTag = false
            return d
          })
          vm.loading = false
        })
    },
    getCount() {
      const vm = this
      insightsApi
        .getResponsesCount(
          this.$router.currentRoute.params.campaignId,
          this.getFilters()
        )
        .then(function(res) {
          vm.pages = Math.ceil(res.data.results / 10)
        })
    },
    getRatingLabels: function(type) {
      if (type === 'NPS') {
        return {
          rated1: 'Detractor',
          rated2: 'Passive',
          rated3: 'Promoter'
        }
      } else if (type === 'SAT') {
        return {
          rated1: strings.SAT.widget_button_labels[0].label,
          rated2: strings.SAT.widget_button_labels[1].label,
          rated3: strings.SAT.widget_button_labels[2].label,
          rated4: strings.SAT.widget_button_labels[3].label,
          rated5: strings.SAT.widget_button_labels[4].label
        }
      } else {
        return {
          rated1: strings.ES.widget_button_labels[0].label,
          rated2: strings.ES.widget_button_labels[1].label,
          rated3: strings.ES.widget_button_labels[2].label,
          rated4: strings.ES.widget_button_labels[3].label,
          rated5: strings.ES.widget_button_labels[4].label
        }
      }
    },
    getDate(dte) {
      return distanceInWords(new Date(), new Date(dte * 1000), {
        includeSeconds: true,
        addSuffix: true
      })
    },
    viewResponse(response) {
      const vm = this
      this.responseDetailsDrawer = true
      this.responseDetailsLoading = true
      insightsApi
        .getResponseDetails(
          this.$router.currentRoute.params.campaignId,
          response.id
        )
        .then(function(res) {
          vm.responseDetails = res.data.results
          vm.responseDetails.responded_at = response.responded_at
          vm.responseDetails.metric_type = response.metric_type
          vm.responseDetails.questions[0].metric_type = response.metric_type
          vm.responseDetailsLoading = false
        })
    },
    getFilters() {
      const q = {
        from: this.$router.currentRoute.query.from,
        to: this.$router.currentRoute.query.to,
        page: this.paging.page,
        limit: this.paging.limit,
        ...this.getAttributeFilters()
      }
      if (
        this.$router.currentRoute.query.m_type &&
        this.$router.currentRoute.query.m_type.toUpperCase() !== 'ALL'
      ) {
        q.m_type = this.$router.currentRoute.query.m_type
      }
      if (
        this.$router.currentRoute.query.text &&
        this.$router.currentRoute.query.text.toUpperCase() !== 'ALL'
      ) {
        q.text = this.$router.currentRoute.query.text
      }
      if (this.$router.currentRoute.query.tags) {
        q.tags = this.$router.currentRoute.query.tags
      }
      return q
    },
    deleteResponse: function() {
      const vm = this
      vm.deleteLoading = true
      insightsApi
        .deleteResponse(
          this.$router.currentRoute.params.campaignId,
          this.responseDetails.id
        )
        .then(function(res) {
          vm.getCount()
          vm.getData()
          vm.deleteLoading = false
          vm.deleteDialog = false
          vm.responseDetailsDrawer = false
        })
    }
  }
}
</script>

<style lang="stylus">
.response-insights {
    width 100%
    position relative
    .response-list{
        max-width 700px
        margin-left: auto;
        margin-right: auto;
    }
    .response-list-item {
        padding 0
        margin-bottom 20px
        min-width: 600px
        .score-area {
            border-top-left-radius 5px
            border-bottom-left-radius 5px
            text-align center
            display flex
            align-items center
            justify-content center
        }
        .response-area {
            border-top-right-radius 5px
            border-bottom-right-radius 5px
            border: 1px solid $color-primary-light-8;
            .top-section {
                max-height 22px
            }
            .customer-name {
              font-size: 14px
              color: $color-primary
              font-weight: 500
            }
            .date-info {
                color: $color-primary-light-5
            }
            .metric-type {
                color: $color-primary
                font-weight 500
            }
            .comment-text {
                margin-top 10px
                font-size 14
                min-height 30px
                /*color: #000*/
                .no-comments {
                    color: $color-primary-light-5
                }
            }
            .view-response-link {
                text-decoration none
                color: $color-primary-light-5
            }
        }
    }

    .response-list-pagination {
        background #fff
        padding 10px
    }

    .response-details-view {
        width 50%
        .response-details-content{
            padding-left 30px
            padding-right 30px
            padding-top 20px
            padding-bottom 20px
        }
        .first-row {
            max-height 40px
            font-size 14px
            margin-bottom 50px
            .customer-name {
              font-size: 14px
              color: $color-primary
              font-weight: 500
            }
            .date-info {
                color: $color-primary-light-5
            }
            .metric-type {
                color: $color-primary
                font-weight 500
            }
            .customer-unique-id {
              margin-top: 5px
              color: $color-primary-light-5
              font-size: 12px
            }
            .close-icon {
                max-width 40px
            }
        }
        .question {
            margin-top 20px
            .metric-label {
                color: $color-primary-light-5
                font-size 14px
            }
            .lgrm-question {
                text-align left
                font-weight 500
                color: $color-primary-light-1
            }
            .text-suggestion {
                text-align left
            }
        }

        .bottom-row {
            max-height 30px
            text-align right
            .delete-img {
                height 24px
                cursor pointer
            }
        }
        .lgrm-nps-label {
          color: $color-primary-light-5 !important
          }
    }

}
</style>
